module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/austin-fruits-background-fdfbffdcfe6a41e240f3f6821a86d193.jpg";